import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store";
import { imdbSearchResultDto, resetSearchState, Status } from "./search-bar.slice";
import "./search-results.css";
import { updateShowViewCount } from "../../api";

export interface SearchResultsProps {
    searchResults: imdbSearchResultDto[];
}

const SearchResults = ({ searchResults }: SearchResultsProps) => {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const resultsStatus = useSelector((state: RootState) => state.searchBar.status);
    if(resultsStatus === Status.ERROR) {
        return (
            <div className="searchResultsError">Error retriving results</div>
        );
    }

    const clickHandler = (id: string, coverImage: string) => {
        dispatch(resetSearchState());
        updateShowViewCount(id, coverImage);
        navigate(`/imdb/${id}`);
    }

    return (
        <>
        {searchResults.map(result => 
            <Grid container direction="row" key={result.id} id={result.id} className="searchResult" onClick={() => clickHandler(result.id, result?.i?.length ? result.i[0] : null)}>
                <Grid item xs={2}>
                    {result?.i?.length > 0 && <img src={result.i[0]} alt={result.l} className="searchResultImage" />}
                </Grid>
                <Grid item xs={10} container direction="column" className="searchResultText">
                    <Grid item className="searchResultShowTitle">{result.l}</Grid>
                    <Grid item>{result.y}</Grid>
                    <Grid item>{result.s}</Grid>
                </Grid>
            </Grid>
        )}
        {searchResults.length === 0 && resultsStatus === Status.SUCCESSFUL &&
            <div className="searchResultsEmpty">No results found</div>
        }
        </>
    );
}

export default SearchResults;